import { render } from "./UiCountrySwitch.vue?vue&type=template&id=7f2c55a8&ts=true&lang=pug"
import script from "./UiCountrySwitch.vue?vue&type=script&setup=true&lang=ts"
export * from "./UiCountrySwitch.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__